if (typeof window.validationsUtil === 'undefined') {
  var validationsUtil = {
    validateIBAN: function (iban) {
      return new Promise(function (resolve, reject) {
        Liferay.Loader.require(['cxov-ui-widgets@1.0.0'], function (uiWidgets) {
          if (uiWidgets) {
            resolve(uiWidgets.validateIban(iban))
          } else {
            console.error('No se pudo cargar cxov-ui-widgets')
            reject(false)
          }
        })
      })
    },
    validateContract: function (document) {
      document = document.toUpperCase().replace(/\s/, '')
      let CONTRACT_REGEX = /^\d{1,10}$/
      return CONTRACT_REGEX.test(document) && document.length <= 10
    },
    validateDocument: function (document) {
      document = document.toUpperCase().replace(/\s/, '')
      return validationsUtil.validateDNI(document) || validationsUtil.validateNIE(document) || validationsUtil.validateCIF(document)
    },
    validateDNI: function (documento) {
      let valid = false
      let DNI_REGEX = /^(\d{8})([A-Z])$/
      if (documento.match(DNI_REGEX)) {
        let letter = documento.charAt(8)
        let letters = 'TRWAGMYFPDXBNJZSQVHLCKE'
        let index = parseInt(documento.substr(0, 8)) % 23
        if (letters.charAt(index) === letter) {
          valid = true
        }
      }

      return valid
    },
    validateNIE: function (documento) {
      let number, letter, letra
      let REGEX = /^[XYZ]?\d{5,8}[A-Z]$/

      documento = documento.toUpperCase()

      if (REGEX.test(documento) === true) {
        number = documento.substr(0, documento.length - 1)
        documento.slice()
        number = number.replace('X', 0)
        number = number.replace('Y', 1)
        number = number.replace('Z', 2)
        letter = documento.substr(documento.length - 1, 1)
        number = number % 23
        letra = 'TRWAGMYFPDXBNJZSQVHLCKET'
        letra = letra.substring(number, number + 1)
        return letra === letter
      } else {
        return false
      }
    },
    validateCIF: function (cif) {
      if (!cif || cif.length !== 9) {
        return false
      }

      let letters = ['J', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']
      let digits = cif.substr(1, cif.length - 2)
      let letter = cif.substr(0, 1)
      let control = cif.substr(cif.length - 1)
      let sum = 0
      let i
      let digit

      let tablaCharsControlNIF = ['T', 'R', 'W', 'A', 'G', 'M', 'Y', 'F', 'P', 'D', 'X', 'B', 'N', 'J', 'Z', 'S', 'Q', 'V', 'H', 'L', 'C', 'K', 'E']

      if (!letter.match(/[A-Z]/)) {
        return false
      }

      // DT-31286 check for old CIF format (K, L, M)
      if (letter.match(/[KLM]/)) {
        let digitsInt = parseInt(digits)
        if (isNaN(digitsInt)) {
          return false
        }
        let controlIndex = digitsInt % 23
        return tablaCharsControlNIF[controlIndex] === control
      }

      for (i = 0; i < digits.length; ++i) {
        digit = parseInt(digits[i])

        if (isNaN(digit)) {
          return false
        }

        if (i % 2 === 0) {
          digit *= 2
          if (digit > 9) {
            digit = parseInt(digit / 10) + (digit % 10)
          }

          sum += digit
        } else {
          sum += digit
        }
      }

      sum %= 10
      if (sum !== 0) {
        digit = 10 - sum
      } else {
        digit = sum
      }

      if (letter.match(/[ABEH]/)) {
        return String(digit) === control
      }
      if (letter.match(/[NPQRSW]/)) {
        return letters[digit] === control
      }

      return String(digit) === control || letters[digit] === control
    },
    validatePassport: function (documento) {
      let regex = /^[a-zA-Z]{3}\d{6}$/
      return regex.test(documento)
    },
    validateEmail: function (value) {
      let email_validation_pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
      return email_validation_pattern.test(value)
    },
    validatePostalCode: function (valor) {
      let postalCode_validation_pattern = /^[0-9]{5}$/
      return postalCode_validation_pattern.test(valor)
    },
    validateNationalMobile: function (mobile) {
      return validationsUtil.validatePhone(mobile, 'ES', 'MOBILE')
    },
    validateInternationalFixedLine: function (phone, country) {
      return validationsUtil.validatePhone(phone, country, 'FIXED_LINE')
    },
    validateInternationalPhone: function (phone, country) {
      return validationsUtil.validatePhone(phone, country, 'MOBILE')
    },
    /**
     * Validates phone through Google library
     *
     * @param phone
     *          Telephone with prefix
     * @param country
     *          Country identifier, optional if provide prefix
     * @param type
     *          The options we use are: MOBILE || FIXED_LINE
     * @returns validation result
     */
    validatePhone: function (phone, country, type) {
      return new Promise(function (resolve, reject) {
        Liferay.Loader.require(['cxov-ui-widgets@1.0.0'], function (uiWidgets) {
          if (uiWidgets) {
            resolve(uiWidgets.validatePhone(phone, country, type))
          } else {
            console.error('No se pudo cargar cxov-ui-widgets')
            reject(false)
          }
        })
      })
    },
    addOk: function (element) {
      element.classList.remove('wrong')
      element.classList.add('correct')
    },
    addError: function (element) {
      element.classList.remove('correct')
      element.classList.add('wrong')
    },
    emptyFieldInfo: function (element) {
      element.classList.remove('wrong')
      element.classList.remove('correct')
    }
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = validationsUtil
  }
}

